import React from 'react';
import clsx from 'clsx';
import MuiCardActionArea from '@material-ui/core/CardActionArea';
import { CARD_ACTION_AREA } from 'ctsutheme/core';

const CardActionArea = ({ className, highlighted, ...props }) => (
  <MuiCardActionArea
    component="div"
    className={clsx(
      CARD_ACTION_AREA.root,
      highlighted && CARD_ACTION_AREA.highlighted,
      className
    )}
    {...props}
  />
);

export default CardActionArea;
